import styled from 'styled-components'
import Mono from '../../../ui/Mono/Mono'

export interface MoneyCellProps {
  value: unknown
  suffix?: string
}

const format = (value: unknown): string => {
  const num = Number(value)
  if (!Number.isFinite(num)) return String(value ?? '')
  return num.toLocaleString('en-US').replace(/,/g, ' ')
}

export const MoneyCell = ({ value, suffix }: MoneyCellProps) => (
  <Money>
    <span>{format(value)}</span>
    {suffix && <Cur>{suffix}</Cur>}
  </Money>
)

export default MoneyCell

const Money = styled(Mono)`
  display: inline-flex;
  align-items: baseline;
  gap: 0.375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
`

const Cur = styled.span`
  color: ${({ theme }) => theme.colors.ink4};
  font-weight: 400;
`
